import React, { useState } from 'react';
import { GradientSelector } from './GradientSelector';

export const ColorOrDisabled = ({ name, value, dependencies, onChange }) => {
  const isGradientSelectorLookUp = dependencies.find(dep => dep.key === "$enable-background-gradient");
  const isGradientSelector = !!(isGradientSelectorLookUp && isGradientSelectorLookUp.value && isGradientSelectorLookUp.value.toLowerCase() === "true");
  return (
    <>
      {isGradientSelector && <GradientSelector name={name}  value={value} onChange={onChange} />}
      {!isGradientSelector && <><br/>Disabled</>}
    </>
  )
}
